import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { setIncompletePicksModalToOpen, setPendingNavigation, resetNavigationModalState } from '../picks/actions';

// Components
import NavMenu from './NavMenu';

const NavMenuBuilder = ({ showNavLinks, routes, ...props }) => {
  const dispatch = useDispatch();
  const { picks, routing } = useSelector((state) => state);
  const { picked, incompletePicksModalOpen, picksSubmitted, picksLocked } = picks;
  const { currentRoute } = routing;

  const slotsPicked = Object.keys(picked)
    .map((id) => picked[id])
    .filter((id) => id);

  const hasPartialPicks = slotsPicked.length > 0 && !picksSubmitted && !picksLocked;

  useEffect(() => {
    if (currentRoute !== 'playNow' && incompletePicksModalOpen) {
      dispatch(resetNavigationModalState());
    }
  }, [currentRoute, incompletePicksModalOpen, dispatch]);

  const navigationGuard = {
    hasPartialPicks,
    incompletePicksModalOpen,
    handleNavigationAttempt: (routeId) => {
      dispatch(setPendingNavigation(routeId));
      dispatch(setIncompletePicksModalToOpen());
    },
  };

  return (
    <NavMenu>
      {showNavLinks && (
        <NavMenu.List>
          {routes.map(({ id, ...rest }) => (
            <NavMenu.Item key={id} routeId={id} navigationGuard={navigationGuard} {...props} {...rest} />
          ))}
        </NavMenu.List>
      )}
    </NavMenu>
  );
};

NavMenuBuilder.propTypes = {
  routes: PropTypes.array,
  showNavLinks: PropTypes.bool,
};

NavMenuBuilder.defaultProps = {
  routes: [
    {
      key: 'link1',
      label: 'Link 1',
      path: '/link1',
    },
    {
      key: 'link2',
      label: 'Link 2',
      path: '/link2',
    },
    {
      key: 'link3',
      label: 'Link 3',
      path: '/link3',
    },
  ],
  showNavLinks: true,
};

export default NavMenuBuilder;
